<template>
    <div>
      <el-row  style="">
        <el-button type="text" size="mini" @click="openSku" style="margin-right: 0px;">SKU信息</el-button>
        <el-button type="text" size="mini" @click="openMate" style="margin-right: 20px;">物料信息</el-button>

        <el-button type="primary" size="mini" @click="openItem(1,null)" style="margin-right: 20px;">添加商品</el-button>

        名称：<el-input size="mini" clearable v-model="itemName" style="width: 150px;"></el-input> <el-button type="primary" size="mini" @click="getItemData" >搜索</el-button>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-table border style="font-size: 12px" ref="multipleTable"
                  :data="itemData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '2px'}">
          <el-table-column  label="序号"  type="index"  :index="indexMethod" width="100px"></el-table-column>
          <el-table-column prop="title" label="商品名称" width="500px"></el-table-column>
          <el-table-column width="160px">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  style="display: inline" @click="openItem(2, scope.row)">更新</el-button>
              <el-button type="text" size="mini"  style="display: inline" @click="deleteItem(scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-row>
      <div class="block" align="center">
        <span class="demonstration"></span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageObject.pageCurrent"
          :page-sizes="[50, 100, 500, 1000, 5000]"
          :page-size="pageObject.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageObject.rowCount">
        </el-pagination>
      </div>

      <el-dialog
        title="添加商品" :visible.sync="showItem" :close-on-click-modal="false" width="550px" center>

        商品名称：<el-input v-model="newItemName" style="width: 400px;"></el-input>

        <el-checkbox v-model="chkContinuous" style="margin-left: 70px; margin-top: 20px">连续添加</el-checkbox>【提示：点确定后，不关闭本窗口】

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveItem">确 定</el-button>

        </span>
      </el-dialog>
    </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";
    export default {
        name: "JxcItem",
      data(){
          return{
            showItem: false,
            chkContinuous: false,
            newItemName:'',
            itemName:'',
            flag:1,
            itemId: 0,
            itemData:[{itemName:'希妹甲油胶希妹美甲4色套系火龙果色2022年新款秋季流行网红美甲'}],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 100
            },
          }
      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getItemData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getItemData();
        },
        openSku(){
          this.$router.replace({name: 'JxcSku'});
        },
        openMate(){
          this.$router.replace({name: 'Material'});
        },
        openItem(flag, row){
          if(flag == 1){
            this.newItemName = '';
            this.flag = 1;
          }else{
            this.newItemName = row.title;
            this.flag = 2;
            this.itemId = row.itemId
          }
          this.showItem = true;
        },
        saveItem(){
          let action = "";
          if(this.flag == 1){
            action = "addItem"
          }else{
            action = "updateItem"
          }
          let param={
            nick: storage.get('nick'),
            itemId: this.itemId,
            title: this.newItemName,
          }
          $api.post("/jxc/"+ action, param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1) {
              this.$message.success("操作已成功！");
              this.getItemData();
              if(!this.chkContinuous){
                this.showItem = false;
              }
            }else{
              this.$message.error(dataResult.data);
            }
          })
        },
        deleteItem(row){
          let param={
            itemId: row.itemId,
          }
          $api.post("/jxc/deleteItem", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.$message.success("删除操作成功！")
              this.getItemData();
            }else{
              this.$message.error('删除失败！');
            }
          })
        },
        getItemData(){
          let param = {
            nick: storage.get('nick'),
            title: this.itemName,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/jxc/getItem", param, response=>{
            let dataResult = response.data;
            console.log(dataResult)
            if(dataResult.state == 1){
              this.itemData = dataResult.data.item;
              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }
          })
        },

      },
      mounted(){
        this.getItemData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/jxc/JxcItem.vue